import { useQuery } from '@tanstack/react-query'
import type { DashboardRecord, IsoDate } from '@henlytics/types'
import { api } from '../lib/api-client'
import { queryKeys } from '../lib/query-keys'

export function useDashboard(asOf: IsoDate) {
  return useQuery({
    queryKey: queryKeys.dashboard(asOf),
    queryFn: ({ signal }) => api.get<DashboardRecord>(`/reports/dashboard?asOf=${asOf}`, signal),
  })
}

/** Today, in the browser's local calendar — the day the farm is entering for. */
export function today(): IsoDate {
  const now = new Date()
  const local = new Date(now.getTime() - now.getTimezoneOffset() * 60_000)
  return local.toISOString().slice(0, 10)
}
